var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('q-card',{staticClass:"checklist-new-modal"},[_c(_setup.checklistsForm,{ref:"formRef",attrs:{"type":"new"},on:{"close-form":_setup.closeForm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }